import React, { useEffect, useState, useRef } from "react";
import * as Sentry from "@sentry/react";
// importing the css
import css from "../../style/booking.module.css";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";

const MapComponent = ({
  hide,
  pickupLocation,
  dropoffLocation,
  stops,
  pickupLatitude,
  pickupLongitude,
  dropoffLatitude,
  dropoffLongitude,
  distanceInKm,
  durationInMins,
  handleUpdateBookingObject,
  isfullscreen,
  mapHeight,
  onRouteCalculationStatusChange,
}) => {
  //   adding maps
  const [mapRef, _] = useState(useRef(null));
  //pickup coordinates
  const [pickupCoordinates, setpickupCoordinates] = useState({
    lat: null,
    lng: null,
  });
  //dropoffcoordinates
  const [dropOffcoordinates, setdropOffcoordinates] = useState({
    lat: null,
    lng: null,
  });

  const setRouteCalculating = (isCalculating) => {
    try {
      if (typeof onRouteCalculationStatusChange === "function") {
        onRouteCalculationStatusChange(isCalculating);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const hasStopsWithCoordinates =
    Array.isArray(stops) &&
    stops.some(
      (stop) =>
        stop &&
        stop.lat !== undefined &&
        stop.long !== undefined &&
        stop.lat !== null &&
        stop.long !== null &&
        stop.lat !== "" &&
        stop.long !== ""
    );

  const shouldComputeRoute =
    Boolean(pickupLocation?.trim()) &&
    (Boolean(dropoffLocation?.trim()) || hasStopsWithCoordinates);

  useEffect(() => {
    setRouteCalculating(shouldComputeRoute);
  }, [shouldComputeRoute]);

  const handleSetCoordinates = async (value, isPickup) => {
    try {
      if (value) {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        isPickup ? setpickupCoordinates(latLng) : setdropOffcoordinates(latLng);
      } else {
        isPickup ? setpickupCoordinates(null) : setdropOffcoordinates(null);
      }
    } catch (error) {
      setRouteCalculating(false);
      Sentry.captureException(error);
      console.log(error);
    }
  };
  useEffect(() => {
    try {
      handleSetCoordinates(pickupLocation, true);
      handleSetCoordinates(dropoffLocation, false);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [pickupLocation, dropoffLocation]);

  useEffect(() => {
    try {
      let google = window?.google;
      if (!google) return;
      let map = mapRef.current;

      const myLatlng = new google.maps.LatLng({
        lat: pickupCoordinates?.lat,
        lng: pickupCoordinates?.lng,
      });
      const dropOffmyLatlng = new google.maps.LatLng(
        dropOffcoordinates?.lat,
        dropOffcoordinates?.lng
      );
      const mapOptions = {
        zoom: 12,
        center: new google.maps.LatLng(51.0543976, -114.0838157),
        scrollwheel: false,
        zoomControl: true,
      };
      if (pickupCoordinates?.lat) {
        mapOptions.center = myLatlng;
      } else if (dropOffcoordinates?.lat) {
        mapOptions.center = dropOffmyLatlng;
      }

      map = mapOptions ? new google.maps.Map(map, mapOptions) : null;

      //Function for directions

      //For Directions from pickup to DropOff
      const mapLocation = () => {
        try {
          let directionsDisplay;
          let directionsService = new google.maps.DirectionsService();
          //Initializes directionDisplay object and calls the calcRoute func
          directionsDisplay = new google.maps.DirectionsRenderer({
            polylineOptions: {
              strokeColor: "#332a88",
              strokeWeight: 5,
              preserveViewport: true,
              suppressMarkers: true,
            },
              markerOptions: {
                icon: {
                  url: "/images/NewUiIcons/locationicon.svg",
                },
              },
          });
          directionsDisplay.setMap(map);
          //creating a waypoint for google direction service for creating a Stop
          var mapStops = [];
          for (let i = 0; i < stops?.length; i++) {
            const address = stops[i];
            if (address !== "") {
              mapStops.push({
                location: {
                  lat: parseFloat(address?.lat),
                  lng: parseFloat(address?.long),
                },
                stopover: true,
              });
            }
          }

          const request = {
            origin: pickupCoordinates,
            destination: dropOffcoordinates,
            waypoints: mapStops,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          };
          if (!dropOffcoordinates && mapStops.length)
            request.destination = request.waypoints.pop().location;

          directionsService.route(request, function (response, status) {
            if (status === google.maps.DirectionsStatus.OK) {
              directionsDisplay.setDirections(response);
              directionsDisplay.setMap(map);
              getResponseFromCalcRoute(response);
              setRouteCalculating(false);
            } else {
              setRouteCalculating(false);
              console.log("Directions not available", status);
            }
          });
        } catch (error) {
          setRouteCalculating(false);
          Sentry.captureException(error);
          console.log(error);
        }
      };

      const getResponseFromCalcRoute = (resp) => {
        try {
          let routeDistance = 0;
          let routeDuration = 0;
          resp.routes[0].legs?.forEach((journey) => {
            routeDistance = routeDistance + journey?.distance?.value;
            routeDuration = routeDuration + journey?.duration?.value;
          });
          if (!pickupCoordinates?.lat && !dropOffcoordinates?.lat) return;
          if (pickupCoordinates?.lat !== pickupLatitude)
            handleUpdateBookingObject(
              "pickupLatitude",
              pickupCoordinates?.lat ?? 0,
              "15.1"
            );
          if (pickupCoordinates?.lng !== pickupLongitude)
            handleUpdateBookingObject(
              "pickupLongitude",
              pickupCoordinates?.lng ?? 0,
              "15.2"
            );
          if (dropOffcoordinates?.lat !== dropoffLatitude)
            handleUpdateBookingObject(
              "dropoffLatitude",
              dropOffcoordinates?.lat ?? 0,
              "15.3"
            );
          if (dropOffcoordinates?.lng !== dropoffLongitude)
            handleUpdateBookingObject(
              "dropoffLongitude",
              dropOffcoordinates?.lng ?? 0,
              "15.4"
            );
          if (Math.ceil(routeDistance / 1000) !== distanceInKm)
            handleUpdateBookingObject(
              "distanceInKm",
              Math.ceil(routeDistance / 1000),
              "15.5"
            );
          if (Math.ceil(routeDuration / 60) !== durationInMins)
            handleUpdateBookingObject(
              "durationInMins",
              Math.ceil(routeDuration / 60),
              "15.6"
            );
        } catch (error) {
          Sentry.captureException(error);
          console.log(error);
        }
      };
      if (
        (pickupCoordinates?.lat && dropOffcoordinates?.lat) ||
        ((pickupCoordinates?.lat || dropOffcoordinates?.lat) && stops?.length)
      ) {
        setTimeout(mapLocation, 100);
      } else if (!shouldComputeRoute) {
        setRouteCalculating(false);
      }
    } catch (error) {
      setRouteCalculating(false);
      Sentry.captureException(error);
      console.log(error);
    }
  }, [
    pickupLocation,
    dropoffLocation,
    dropOffcoordinates,
    pickupCoordinates,
    stops,
    shouldComputeRoute,
  ]);

  return (
    <>
      {/* {isMapActive && ( */}
      <>
        {/* If hidden, render nothing */}
        {hide ? null : (
          <div
            className={css?.mapDiv}
            style={
              isfullscreen
                ? {
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 0,
                  }
                : {
                    position: "absolute",
                    width: "100%",
                    height: mapHeight ? mapHeight : "300px",
                    overflow:"auto"
                  }
            }
            ref={mapRef}
          />
        )}
      </>
    </>
  );
};

export default MapComponent;
